// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"44dec74e","99":"6cc1403e","146":"84cfd346","175":"388da00f","204":"4ccddf09","349":"ae0a81b4","453":"c3f3c335","479":"85c5f817","655":"4de2c9f2","674":"5bef9fb3","768":"359e4be5","813":"925f9e7a","963":"2dfc4b61"}[chunkId] + ".chunk.js";
};